import { Component } from '@angular/core'
import { ShellService } from 'src/app/services/shell.service'

/** Hosted once in app.component.html; shows ShellService.toast(). */
@Component({
  selector: 'rt-toast',
  template: `
    <div *ngIf="shell.toast$ | async as t" class="rt-toast rt-toast--{{ t.tone ?? 'ok' }}" role="status">
      <span class="rt-toast__mark" aria-hidden="true">{{ t.tone === 'error' ? '!' : '✓' }}</span>
      <div class="rt-toast__text">
        <b>{{ t.title }}</b>
        <span *ngIf="t.sub">{{ t.sub }}</span>
      </div>
      <button type="button" class="rt-toast__close" aria-label="Close" (click)="shell.dismissToast()">×</button>
    </div>`,
})
export class RtToastComponent {
  constructor(readonly shell: ShellService) {}
}
